import { makeStyles } from '@material-ui/core/styles'
import { DESKTOP_TOOLBAR_WIDTH, MOBILE_TOOLBAR_WIDTH, TOOLBAR_OFFSET } from './useEditor.const'

const useStyles = makeStyles(
	theme => ({
		toolbar: {
			display: 'flex',
			flexDirection: 'column',
			'& .tox.tox-tinymce-inline': {
				marginLeft: '0 !important',
			},
			'& .tox-tinymce-inline .tox-editor-container': {
				display: 'block !important',
				'&:before, &:after': {
					display: 'none !important',
				},
				[theme.breakpoints.down('sm')]: {
					maxWidth: ({ variant }) => `${MOBILE_TOOLBAR_WIDTH[variant]}px !important`,
					width: ({ variant }) => `${MOBILE_TOOLBAR_WIDTH[variant]}px !important`,
				},
				[theme.breakpoints.up('sm')]: {
					maxWidth: ({ variant }) => `${DESKTOP_TOOLBAR_WIDTH[variant]}px !important`,
					width: ({ variant }) => `${DESKTOP_TOOLBAR_WIDTH[variant]}px !important`,
				},
			},
		},
		leftToolbar: {
			'& .tox-tinymce-inline .tox-editor-container': {
				position: 'absolute !important',
				right: 'unset !important',
				left: '0 !important',
			},
		},
		rightToolbar: {
			'& .tox-tinymce-inline .tox-editor-container': {
				position: 'absolute !important',
				left: 'unset !important',
				right: '0 !important',
			},
		},
		centerToolbar: {
			'& .tox-tinymce-inline .tox-editor-container': {
				right: 'unset !important',
				left: '0 !important',
				[theme.breakpoints.down('sm')]: {
					marginLeft: ({ variant }) => `-${MOBILE_TOOLBAR_WIDTH[variant] / 2}px !important`,
				},
				[theme.breakpoints.up('sm')]: {
					marginLeft: ({ variant }) => `-${DESKTOP_TOOLBAR_WIDTH[variant] / 2}px !important`,
				},
			},
		},
		topToolbar: {
			justifyContent: 'flex-end',
			'& .tox-tinymce-inline .tox-editor-container': {
				marginBottom: 8,
				top: 'unset !important',
				bottom: `${TOOLBAR_OFFSET}px !important`,
			},
		},
		bottomToolbar: {
			'& .tox-tinymce-inline .tox-editor-container': {
				marginTop: 8,
				bottom: 'unset !important',
				top: `${TOOLBAR_OFFSET}px !important`,
			},
		},
		fixedToolbar: {
			'& .tox-tinymce-inline .tox-editor-container': {
				top: '0 !important',
				bottom: 'unset !important',
			},
		},
		'@global': {
			'body .tox .tox-collection__item .tox-collection__item-label *': {
				whiteSpace: 'nowrap',
			},
			'body .tox .tox-collection__item[title^="Heading"] .tox-collection__item-label *': {
				lineHeight: 1.4,
			},
			// eslint-disable-next-line max-len
			'body .tox .tox-collection__item[title="Accent text"] .tox-collection__item-label *, body .tox .tox-collection__item[title^="Heading"] .tox-collection__item-label *': {
				color: ({ focused }) => (focused ? `${theme.palette.common.textPrimary} !important` : null),
			},
		},
	}),
	{ name: 'Editor' },
)

export default useStyles
